











































































































































































































































import {
  Component,
  Prop,
  Vue,
  Mixins,
  Watch,
  InjectReactive
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { specialChannel } from "@root/lib/mixins";
import channelAttrBrand from "@/components/pages/ProductCreate/channelComponents/channelAttrBrand.vue";
import skuImage from "@/components/pages/ProductCreate/skuImage.vue";
import multiLangEnter from "@/components/pages/ProductCreate/multiLangEnter.vue";
import channelEditMultiLanguage from "@/components/pages/ProductCreate/channelComponents/channelEditMultiLanguage.vue";
import channelAttrSelect from "@/components/pages/ProductCreate/channelComponents/channelAttrSelect.vue";
import channelSkuMedia from "@/components/pages/ProductCreate/channelComponents/channelSkuMedia.vue";
@Component({
  components: {
    channelAttrBrand,
    multiLangEnter,
    channelEditMultiLanguage,
    skuImage,
    channelAttrSelect,
    channelSkuMedia
  }
})
export default class channelAttrItem extends Mixins(specialChannel) {
  @InjectReactive("curChannel") curChannel;
  // @InjectReactive("channelLocale") channelLocale;
  // 0：单选；1：多选；2：输入框；3：数字；4：富文本；5：日期；6：对象；7：单选可输入；8：多选可输入，9：其他,10：多个可输入框,11:文本编辑器,12:图片,13:视频
  @Prop({ default: () => {} }) node; // 属性结构数据对象
  @Prop({ default: () => "" }) dataValue; // 需要回显的值
  @Prop({ default: () => [] }) languageList; // 需要回显的值
  @Prop({ default: false }) textInput; // 输入框是否仅为显示
  @Prop({ default: false }) readonly; // 是否只读
  specialType = ["brandCode", "images"];
  curValue = "";
  channelLocale = localStorage.getItem("channelLocale");
  curEditMultiKey = "";
  @Watch("dataValue", { immediate: true })
  watchDataValue(val) {
    this.curValue = val;
  }
  @Watch("curValue", { deep: true })
  watchCurValue(val) {
    this.$emit("update:dataValue", val);
  }
  // 是否是多语言属性
  get ismultiLanguages() {
    return !!(this.node.languages && this.node.languages.length);
  }
  // 编辑多语言
  editMultiOption() {
    const $edit: any = this.$refs.channelEditMultiLangDialog;
    $edit.dialogVisible = true;
  }
  // 保存多语言到表单
  saveMultiOption(data) {
    this.curValue = { ...data };
  }

  editImages() {
    this.$emit("editImages");
  }
  // onsuccess(url) {
  //   this.curValue = url;
  // }
  // onRemove(index, fileList) {
  //   this.curValue = "";
  // }
  changeSkuMediaFn(url) {
    this.curValue = url;
  }
}
